import React, { useState, useEffect } from "react";
import F1 from "../../Assessts/Images/Home/Banners/HF1.png";
import F2 from "../../Assessts/Images/Home/Banners/HF2.png";
import F3 from "../../Assessts/Images/Home/Banners/HF3.png";
import F4 from "../../Assessts/Images/Home/Banners/HF4.png";

import IOText from "../../ReUableComponents/ImageOntext";
import { useNavigate } from "react-router-dom";
import { FiFileText } from "react-icons/fi";
import { FaLessThan, FaGreaterThan } from "react-icons/fa";
const SlidingFrame = () => {
  const navigate = useNavigate();
  const [Index, SetIndex] = useState(0);
  const Data = [
    {
      Image: F1,
      // text: <div className="Text-MainDiv" >
      //     <div> College Merit Scholarships for Future Professionals</div>
      //     <div className="mt-3 mb-3 Text-Content">North South Foundation supports meritorious students pursuing engineering, medicine, and other professional degrees through need-based merit scholarships. </div>
      //     <button className="Website-Buttons" style={{ backgroundColor: "#F7D670", color: "#000000" }}
      //     onClick={() => window.open("https://portal.northsouth.org/app6/MainTest.aspx?_gl=1*1k6hnm5*_ga*MTEzODQwNjc1MS4xNzQ4ODM5Njgz*_ga_NFGY5F210T*czE3NzAzNzM4MTMkbzMwJGcxJHQxNzcwMzc0NDY4JGo0OCRsMCRoMTkxNzc4OTA1Mw..", "_blank")}><FiFileText/>Apply Now</button>
      // </div>,
    },
    {
      Image: F2,
      // text: <div className="Text-MainDiv" >
      //     <div>High School Scholarships for Academic Continuity</div>
      //     <div className="mt-3 mb-3 Text-Content ">North South Foundation helps deserving students complete high school by providing scholarships that significantly reduce financial barriers to education. </div>
      //     <button className="Website-Buttons" style={{ backgroundColor: "#F7D670", color: "#000000" }}
      //     onClick={() => window.open("https://portal.northsouth.org/app6/MainTest.aspx?_gl=1*1k6hnm5*_ga*MTEzODQwNjc1MS4xNzQ4ODM5Njgz*_ga_NFGY5F210T*czE3NzAzNzM4MTMkbzMwJGcxJHQxNzcwMzc0NDY4JGo0OCRsMCRoMTkxNzc4OTA1Mw..", "_blank")}><FiFileText/>Apply Now</button>
      // </div>
    },
    {
      Image: F3,
      // text: <div className="Text-MainDiv" >
      //     <div>Designated Scholarships Backed by Donors</div>
      //     <div className="mt-3 mb-3 Text-Content">North South Foundation administers donor-supported scholarships for specific courses or institutions, ensuring targeted and transparent student support.</div>
      //     <button className="Website-Buttons" style={{ backgroundColor: "#F7D670", color: "#000000" }}
      //     onClick={() => window.open("https://portal.northsouth.org/app6/MainTest.aspx?_gl=1*1k6hnm5*_ga*MTEzODQwNjc1MS4xNzQ4ODM5Njgz*_ga_NFGY5F210T*czE3NzAzNzM4MTMkbzMwJGcxJHQxNzcwMzc0NDY4JGo0OCRsMCRoMTkxNzc4OTA1Mw..", "_blank")}><FiFileText/>Apply Now</button>
      // </div>
    },
    {
      Image: F4,
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      SetIndex((prev) => (prev + 1) % Data.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  return (
    <div className="mt-2" style={{ position: "relative" }}>
      <div className="dflex alignitems" style={{ position: "relative" }}>
        <div
          className="HBButtons LButton"
          onClick={() => {
            SetIndex((prev) => (prev === 0 ? Data.length - 1 : prev - 1));
          }}
        >
          <FaLessThan />
        </div>
        <IOText
          Image={Data[Index].Image}
          Alt="EMpower"
          // Text={Data[Index].text}
          Text={
            <div className="Text-MainDiv">
              <div> Encouraging Excellence in Education</div>
              <div className="mt-3 mb-3 Text-Content">
                NorthSouth Foundation (NSF) India, a non profit volunteer -
                driven organization, has been offering merit cum means
                scholarships to economically disadvantaged yet academically
                bright students pursuing Professional Courses. NSF has supported
                11,000+ students across 28 chapters since its inception.
              </div>
              <button
                className="Website-Buttons"
                style={{ backgroundColor: "#F7D670", color: "#000000" }}
                onClick={() =>
                  window.open(
                    "https://portal.northsouth.org/app6/MainTest.aspx?_gl=1*1k6hnm5*_ga*MTEzODQwNjc1MS4xNzQ4ODM5Njgz*_ga_NFGY5F210T*czE3NzAzNzM4MTMkbzMwJGcxJHQxNzcwMzc0NDY4JGo0OCRsMCRoMTkxNzc4OTA1Mw..",
                    "_blank",
                  )
                }
              >
                <FiFileText />
                Apply Now
              </button>
            </div>
          }
        />
        <div
          className="HBButtons RButton"
          onClick={() => {
            SetIndex((prev) => (prev + 1) % Data.length);
          }}
        >
          <FaGreaterThan />
        </div>
      </div>

      <div className="dflex gap-3 JCCenter All_Dots">
        {Data.map((_, i) => (
          <button
            key={i}
            onClick={() => SetIndex(i)}
            className={`DOts ${i === Index ? "Dots-Active" : ""}`}
          />
        ))}
      </div>
    </div>
  );
};
export default SlidingFrame;
